import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { devices } from '../../utilities/responsive';

export const Pagination = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 80px;

    @media ${devices.phoneSm} {
        margin-top: 40px;
    }

    .btn {
        color: var(--green);
        padding: 16px 32px;
        background: transparent;
        font-weight: 400;
        border-radius: 100px;
        transition: all .3s ease; 

        svg {
            width: 24px;
            height: 24px;
        }

        @media ${devices.phoneSm} {
            margin: 10px 20px;
        }

        &:hover {
            color: var(--primary);
        }

        &:focus {
            outline: none;
        }

        &.active {
            border: 1px solid var(--primary);
            color: var(--secondary-paragraph-color);

            &:hover {
                border: 1px solid var(--primary);
                color: var(--secondary-paragraph-color);
            }
        }

        &:not(:last-child) {
            @media ${devices.phoneSm} {
                margin-right: 15px;
            }
        }
    }
`;

export const PaginationLink = styled(Link)<{ disabled: boolean }>`
    ${({ disabled }) => disabled && css`
        cursor: not-allowed !important;
        color: gray !important;
        opacity: .3;
        pointer-events: none;
    `}
`